const BASE = '/app/routing/forms'

export const newFormUrl = (step) => `${BASE}/new/${step}`
export const editFormUrl = (id, step = 'fields') => `${BASE}/${id}/edit/${step}`
export const formResponsesUrl = (id) => `${BASE}/${id}/responses`
